import React, { useRef } from 'react';
import WorkItemForm from '../components/WorkItemForm';
import ActionSelector from '../../common/components/ActionSelector';
import Notification from '../components/Notification';
import { useWorkItemManager } from '../../common/hooks/useWorkItemManager';
import { useProjectContextProviderContext } from '../../common/hooks/useProjectContextProviderContext';
import { Configuration } from '../../common/clients/ogg';
import config from '../config.json';
import { OggFieldService } from '../../common/services/ogg.service';
import OutsetaAuthenticationProvider from '../services/outsetaAuthentication.service';
import { useOutsetaAuth } from '../../common/hooks/outsetaAuthProvider';
import styled from 'styled-components';

const PromptContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 1.3rem;
  flex-grow: 1;
  padding-bottom: 16px;
`;

export default function ContentView() {
  const workItemManager = useWorkItemManager();
  const projectContextProvider = useProjectContextProviderContext();
  const authContext = useOutsetaAuth();
  const wiFormRef = useRef<any>();

  const authProvider = new OutsetaAuthenticationProvider(authContext);
  const apiConfig = new Configuration({
    basePath: config.OggApiUrl,
    accessToken: () => authProvider.getBearerToken(),
  });

  const oggService = new OggFieldService(
    workItemManager,
    apiConfig,
    projectContextProvider,
    authProvider
  );
  oggService.setValidationLogic(async () => wiFormRef.current.validate());

  return (
    <div className='flex-column flex-grow'>
      <WorkItemForm
        wiManager={workItemManager}
        pcProvider={projectContextProvider}
        ref={wiFormRef}
      ></WorkItemForm>
      <Notification />

      {!!authContext.user && (
        <PromptContainer>
          <ActionSelector
            apiConfig={apiConfig}
            oggService={oggService}
            authManager={authProvider}
          />
        </PromptContainer>
      )}
    </div>
  );
}
